import { Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router, RouterLink, RouterLinkActive } from '@angular/router';
import { elementHelp } from '@siemens/element-icons';
import { addIcons, SiIconComponent } from '@siemens/element-ng/icon';
import { filter, map } from 'rxjs';
import { GlobalSearchComponent } from '@shared/components/global-search/global-search.component';
import { UserComponent } from '@shared/components/user/user.component';
import { NavItem } from '@shared/models/nav-item.model';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    imports: [GlobalSearchComponent, RouterLink, RouterLinkActive, SiIconComponent, UserComponent]
})
export class HeaderComponent {
    private readonly router = inject(Router);

    protected readonly icons = addIcons({
        elementHelp
    });

    protected readonly navItems: NavItem[] = [
        { label: 'Meine Aktivitäten', routerLink: '/my-activities', exact: false },
        { label: 'Workstreams', routerLink: '/workstreams', exact: false },
        { label: 'Methodenkoffer', routerLink: '/toolbox', exact: false },
        { label: 'PM', routerLink: '/admin/informal', exact: true },
        { label: 'Aktivitätsanzeige', routerLink: '/activity-feed', exact: false },
        {
            label: 'Admin',
            routerLink: '/admin',
            exact: false,
            excludedLinks: ['/admin/informal']
        }
    ];

    private readonly currentUrl = toSignal(
        this.router.events.pipe(
            filter((event): event is NavigationEnd => event instanceof NavigationEnd),
            map(event => event.urlAfterRedirects)
        ),
        { initialValue: this.router.url }
    );

    protected isActive(item: NavItem): boolean {
        const url = this.currentUrl().split(/[?#]/)[0];
        if (item.excludedLinks?.some(link => this.matches(url, link, false))) {
            return false;
        }
        return this.matches(url, item.routerLink, item.exact);
    }

    private matches(url: string, link: string, exact: boolean): boolean {
        return exact ? url === link : url === link || url.startsWith(`${link}/`);
    }
}
